<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row">
            <div class="col-3">
              <h2 class="card-title-desc"> All Stock</h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-2" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <button v-else class="btn btn-info me-1" @click="downloadStockReport">Download Stock Report</button>
            </div>
            <div class="col-5" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <div v-else class="d-flex">
                <date-picker v-model="stockMovementDate" range class="me-3" placeholder="Select Dates"></date-picker>
                <button class="btn btn-info me-1 w-100" @click="downloadStockMovementReport">Download Stock Movement Report</button>
              </div>
            </div>
          </div>
          <div class="row mb-4">

          </div>
          <TableLoading v-if="stocks.page === 0"/>
          <div v-else>
            <stock-table :rows="stocks.objects" :columns="columns" :current-page="currentPage" @updateStockInfo="updateStocks" @onSearch="searchFn"/>
            <b-pagination
                v-model="currentPage"
                :total-rows="stocks.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import StockTable from "@/components/stock/stock-table";
import {ALL_STOCK} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import {mapActions, mapGetters} from "vuex";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {errorToast} from "@/components/successToast";
import moment from "moment";

export default {
  page: {
    title: "Stock",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, StockTable, PageHeader, Layout},
name: "stock",
  data() {
    return {
      title: "Stock",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Stock",
          active: true
        }
      ],
      stocks: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      columns: [
        {
          field: 'warehouseId.name',
          label: 'Warehouse'
        },
        {
          field: 'productId.productName',
          label: 'Product Name'
        },
        {
          field: 'productId.code',
          label: 'Product Code'
        },
        {
          field: 'quantityCase',
          label: 'QTY (C/S)'
        },
        {
          field: 'quantityBall',
          label: 'QTY (Ball)'
        },
        {
          field: 'quantityPiece',
          label: 'QTY (Pieces)'
        },
        {
          field: 'quantity',
          label: 'Order Unit Qty'
        },
        {
          field: 'actions',
          label: 'Actions'
        },
      ],
      stockMovementDate: ""
    }
  },
  apollo: {
    stocks: {
      query: ALL_STOCK,
      variables(){
        return {
          page: this.currentPage,
          perPage: 30,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    })
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      generateStockReport: 'http/generateStockReport',
      generateStockMovementReport: 'http/generateStockMovementReport'
    }),
    updateStocks(){
      this.$apollo.queries.stocks.refetch()
    },
    searchFn(data){
      this.searchKeyword = data
    },
    async downloadStockReport(){
      const response = await this.generateStockReport()
      if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        const today = moment().format('YYYY-MM-DD')
        downloadFileConfig(response, `Stock Report on ${today}.xlsx`)
      }else {
        errorToast('Error generating stock report')
      }
    },
    async downloadStockMovementReport(){
      if (this.stockMovementDate !== ''){
        const start = moment(this.stockMovementDate[0]).format('YYYY-MM-DD')
        const end = moment(this.stockMovementDate[1]).format('YYYY-MM-DD')
        const response = await this.generateStockMovementReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Stock Movement ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating Stock Movement report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    },
  }
}
</script>

<style scoped>

</style>
